import React, { useEffect, useRef, useState } from 'react'
import { Close } from '@mui/icons-material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function ModalForAll({
    children,
    className = 'modal-default',
    stateModal = false,
    setStateModal,
    iconType = 'close',
    iconColor = '#000',
    iconSize = '25px',
    styleButton = {},
    stateMiniModal = false,
    setStateMiniModal = (() => { }),
    sudChildren
}) {
    const refModal = useRef(null);

    const getIcon = {
        close: <Close style={{ fontSize: iconSize, color: iconColor }} />,
        back: <ArrowBackIcon style={{ fontSize: iconSize, color: iconColor }} />,
    }

    function closeModal() {
        setStateMiniModal(false);
        setStateModal(false);
    }

    useEffect(() => {
        function manejarClickFuera(event) {
            if (refModal.current && !refModal.current.contains(event.target) && event.target.className == 'black-screen') closeModal();
        }
        document.addEventListener('mousedown', manejarClickFuera);

        return () => {
            document.removeEventListener('mousedown', manejarClickFuera);
        };
    }, []);

    useEffect(() => {
        const view_home = document.getElementById('main-page');

        if (stateModal) {
            document.documentElement.style.setProperty('--handle-scroll', 'hidden');
            document.body.style.overflow = "hidden";
            if (view_home) view_home.style.overflow = 'hidden';
        } else {
            document.documentElement.style.setProperty('--handle-scroll', 'auto');
            if (view_home) view_home.style.overflow = 'auto';
            document.body.style.overflow = "auto";
        }
    }, [stateModal])

    return (
        <div className='black-screen' style={{ display: stateModal ? 'flex' : 'none', overflow: 'hidden' }}>
            <div ref={refModal} className={className}>
                <button className='default-buttons close-modal' style={styleButton} onClick={closeModal}>
                    {getIcon[iconType] ?? getIcon.close}
                </button>

                {!stateMiniModal ? children : sudChildren()}
            </div>

            {/* <div className={className} style={{ display: !stateMiniModal ? 'none' : 'flex' }}>
                {sudChildren()}
            </div> */}
        </div>
    )
}
